export default __webpack_public_path__ + "static/media/NCASH.21bd8152.png";